import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	compass: {
		id: 'compass.components-left-panel.header',
		defaultMessage: 'Compass',
		description: 'The text is for the left panel header about compass brand name',
	},
	title: {
		id: 'compass.components-left-panel.title',
		defaultMessage:
			'Create a catalog of your repositories linked in Jira and measure the health and performance of it for free',
		description: 'The text is for the left panel title',
	},
	description: {
		id: 'compass.components-left-panel.description',
		defaultMessage:
			'Catalog these components and use them to track performance, health, and identify dependencies. Link work items to components – so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward.',
		description: 'The text is for the left panel description',
	},
	createYourCatalogButton: {
		id: 'compass.components-left-panel.create-your-catalog.button',
		defaultMessage: 'Create your catalog in Compass',
		description: 'The text is for the left panel createYourCatalog Button',
	},
});
